export default __webpack_public_path__ + "static/media_02-e942c78b9570b3257040a35865d55cca.jpg";